import React, { useEffect, useState } from "react";
import { CloseIcon, HeaderIcon, NewChatIcon } from "../icons";

const Header: React.FC<{
  clearState: Function;
  isNewChatDisabled: boolean;
}> = ({ clearState, isNewChatDisabled }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.screen.width <= 425 || window.innerWidth <= 425);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const closeChat = () => {
    window.parent.postMessage("closeChatbot", "*");
  };

  return (
    <div className="header">
      <div className="heading">
        <div className="icon">
          <HeaderIcon />
        </div>
        <div>
          <p>b1Assistant</p>
        </div>
      </div>
      {isSmallScreen ? (
        <div className={`menu-dropdown ${isOpen ? "open" : ""}`}>
          <button className="burger-icon" onClick={handleToggle}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          {isOpen && (
            <ul className="menu-items">
              <li>
                <button
                  onClick={() => clearState()}
                  disabled={isNewChatDisabled}
                >
                  New Chat
                </button>
              </li>
              <li>
                <button id="close-chat" onClick={() => closeChat()}>
                  Close
                </button>
              </li>
            </ul>
          )}
        </div>
      ) : (
        <div className="actions">
          <button onClick={() => clearState()} disabled={isNewChatDisabled}>
            <span className="tooltip" style={{ right: "110px", display: "flex", alignItems: 'center' }}>
              Start a new chat!
            </span>
            <div className="icon-bordered">
              <NewChatIcon />
            </div>
          </button>
          <button id="close-chat" onClick={() => closeChat()}>
            <div className="icon-bordered-transparent">
              <CloseIcon />
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
